
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gold-loans",
      function () {
        return require("private-next-pages/gold-loans/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gold-loans"])
      });
    }
  